import createCrudService from '@/services/_crudService';

export default createCrudService('/master/notification_recipient');
